if (!customElements.get('testimonial-carousel')) {
  customElements.define(
    'testimonial-carousel',
    class TestimonialCarousel extends HTMLElement {
      constructor() {
        super();
        this.viewportNode = this.querySelector('.testimonial-carousel__slider-viewport');
        this.prevBtnNode = this.querySelector('.testimonial-carousel__prev');
        this.nextBtnNode = this.querySelector('.testimonial-carousel__next');

        this.embla = EmblaCarousel(this.viewportNode, { align: 'center', slidesToScroll: 1 });
        this.prevBtnNode.addEventListener('click', this.previous.bind(this), false);
        this.nextBtnNode.addEventListener('click', this.next.bind(this), false);

        this.embla
          .on('select', this.togglePrevNextBtnsState.bind(this))
          .on('init', this.togglePrevNextBtnsState.bind(this))
          .on('reInit', this.togglePrevNextBtnsState.bind(this));
      }

      previous(e) {
        e.preventDefault();
        this.embla.scrollPrev();
      }

      next(e) {
        e.preventDefault();
        this.embla.scrollNext();
      }

      togglePrevNextBtnsState() {
        if (this.embla.canScrollPrev()) {
          this.prevBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.prevBtnNode.classList.add('arrow-button--disabled');
        }

        if (this.embla.canScrollNext()) {
          this.nextBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.nextBtnNode.classList.add('arrow-button--disabled');
        }
      }
    },
  );
}
